(function () {
  document.addEventListener('contextmenu', function (e) {
    if (e.target.closest('img, picture, .image-wrap, image-element')) {
      e.preventDefault();
    }
  });

  document.addEventListener('dragstart', function (e) {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
    }
  });

  document.addEventListener('keydown', function (e) {
    var key = e.key ? e.key.toLowerCase() : '';
    var blockedWithCtrl = ['s', 'u'];
    if ((e.ctrlKey || e.metaKey) && blockedWithCtrl.indexOf(key) !== -1) {
      e.preventDefault();
    }
  });
})();
